/**
 * Configuration of the environments (test, stage, production and local development), selected at runtime by the domain of
 * the page: the same build is deployed to every environment.
 */
class Configuration {
    // domains of environments (hardcoded - react doesn't allow changes on runtime)
    readonly testDomain = 'test.instantcombine.com';
    readonly stageDomain = 'stage.instantcombine.com';
    readonly productionDomain = 'app.instantcombine.com';

    // configuration attributes
    apiUrl: string;
    apiUrlV2: string;
    awsAuth: any;
    // third party services: undefined turns them off (not loaded, links hidden)
    googleAnalyticsId: string | undefined;
    googleCaptcha: string | undefined;
    hotjarId: number | undefined;
    quickbooksApi: string | undefined;
    quickbooksUrl: string | undefined;
    stripeCustomerPortalUrl: string | undefined;

    constructor() {
        // set up configuration attributes based on environment
        // (instantcombine-core serves the legacy api and the api v2 from the same host).
        // the third party services (Google Analytics, Hotjar, reCAPTCHA, QuickBooks auth link of the legacy Payments service,
        // Stripe customer portal, and the Facebook Pixel of public/index.html) only run in production: the other environments
        // must not send data to them nor act on the legacy accounts (e.g. the QuickBooks link of the legacy stage payments).
        // TODO: production still uses the legacy top100sports accounts - change them to the InstantCombine ones later
        if (window.location.hostname.endsWith(this.testDomain)) {
            this.apiUrl = 'https://core.api.test.instantcombine.com';
            this.apiUrlV2 = 'https://core.api.test.instantcombine.com';
            // TODO: SecurityStack outputs of the test account (not deployed yet): user pool id and UserPoolAppClient id
            this.awsAuth = this.createAwsAuth('TODO', 'TODO');
            this.disableThirdParties();
        } else if (window.location.hostname.endsWith(this.stageDomain)) {
            this.apiUrl = 'https://core.api.stage.instantcombine.com';
            this.apiUrlV2 = 'https://core.api.stage.instantcombine.com';
            // SecurityStack outputs of the stage account: user pool id and UserPoolAppClient id
            this.awsAuth = this.createAwsAuth('us-east-1_CH6KDDhjl', '79gjbrfridg9fo4448s1rpevsf');
            this.disableThirdParties();
        } else if (window.location.hostname.endsWith(this.productionDomain)) {
            this.apiUrl = 'https://core.api.app.instantcombine.com';
            this.apiUrlV2 = 'https://core.api.app.instantcombine.com';
            // TODO: SecurityStack outputs of the production account (not deployed yet): user pool id and UserPoolAppClient id
            this.awsAuth = this.createAwsAuth('TODO', 'TODO');
            this.googleAnalyticsId = 'G-CJPL1EKWZD';
            this.googleCaptcha = '6Lf09hAgAAAAABSogBECLniL3EHY3Eg3t_d6_m3E';
            this.hotjarId = 2814064;
            this.quickbooksApi = 'https://api.intuit.com';
            this.quickbooksUrl = 'https://api.top100sports.com/payments/v1/quickbooks/auth-init';
            this.stripeCustomerPortalUrl = 'https://billing.stripe.com/p/login/3cs6pj7Yd8jH1Ve288';
        } else {
            // local development: instantcombine-core running locally and the Cognito user pool of the dev account (DevStack outputs)
            this.apiUrl = 'http://localhost:8010';
            this.apiUrlV2 = 'http://localhost:8010';
            this.awsAuth = this.createAwsAuth('us-east-1_r66dRgPXj', '7709cro2f4qspea822osagcsfm');
            this.disableThirdParties();
        }
    }

    /**
     * Turns the third party services off (environments other than production).
     */
    private disableThirdParties() {
        this.googleAnalyticsId = undefined;
        this.googleCaptcha = undefined;
        this.hotjarId = undefined;
        this.quickbooksApi = undefined;
        this.quickbooksUrl = undefined;
        this.stripeCustomerPortalUrl = undefined;
    }

    /**
     * Returns the Amplify auth configuration. The web client signs in with USER_PASSWORD_AUTH, i.e. the UserPoolAppClient
     * of the user pool (instantcombine-infrastructure), which has no secret.
     * @param userPoolId the user pool id
     * @param userPoolWebClientId the id of the UserPoolAppClient
     * @returns the Amplify auth configuration
     */
    private createAwsAuth(userPoolId: string, userPoolWebClientId: string) {
        return {
            Auth: {
                region: 'us-east-1',
                userPoolId: userPoolId,
                userPoolWebClientId: userPoolWebClientId,
                authenticationFlowType: 'USER_PASSWORD_AUTH',
            },
        };
    }
}
const configuration: Configuration = new Configuration();
export default configuration;
